'use client';

import { authStore } from '@wwe-portal/web/providers/stores/auth-store';
import { useEffect } from 'react';

export const AuthHydration = () => {
  useEffect(() => {
    authStore.getState().hydrate();
  }, []);
  return null;
};
